
// Set a Cookie
window.setCookie = function(name, value, exp_days) {
	let date = new Date();
	date.setTime(date.getTime() + (exp_days * 24 * 60 * 60 * 1000));
	const expires = "expires=" + date.toUTCString();
	document.cookie = name + "=" + value + "; " + expires + "; path=/";
}
// Get a Cookie
window.getCookie = function(name) {
	const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	if (match) return match[2];
}